import {
  MdAssignmentTurnedIn,
  MdBadge,
  MdCalendarMonth,
  MdCalendarToday,
  MdCall,
  MdCategory,
  MdInventory2,
  MdLanguage,
  MdMail,
  MdPerson,
  MdPhone,
  MdSchedule,
  MdStar,
  MdSupervisorAccount,
  MdToggleOn,
} from "react-icons/md";

const FIELD_TYPES = {
  TEXT: "text",
  NUMBER: "number",
  DATE: "date",
  SELECTION: "selection",
};

export const LEAD_TYPES = {
  MISE_EN_RELATION: "Mise en relation",
  CSM: "CSM",
  NOUVEAU_LEAD: "Nouveau lead",
};

export const ADVANCED_FILTERS = {
  PROJECT: {
    savedFilterType: "saved_filter",
    fields: {
      CLIENT_LASTNAME: {
        key: "contact.user.lastname",
        type: FIELD_TYPES.TEXT,
        icon: MdPerson,
        labelKey: "CLIENT_LASTNAME",
        optional: false,
      },
      CLIENT_FIRSTNAME: {
        key: "contact.user.firstname",
        type: FIELD_TYPES.TEXT,
        icon: MdPerson,
        labelKey: "CLIENT_FIRSTNAME",
        optional: false,
      },
      PHONE: {
        key: "contact.telecoms.phone",
        type: FIELD_TYPES.TEXT,
        icon: MdPhone,
        labelKey: "PHONE",
        optional: false,
      },
      EMAIL: {
        key: "contact.telecoms.email",
        type: FIELD_TYPES.TEXT,
        icon: MdMail,
        labelKey: "EMAIL",
        optional: false,
      },
      AGE: {
        key: "contact.user.age",
        type: FIELD_TYPES.NUMBER,
        icon: MdCalendarToday,
        labelKey: "AGE",
        optional: false,
      },
      LEAD_TYPE: {
        key: "contact.fields.leadType",
        type: FIELD_TYPES.SELECTION,
        icon: MdCategory,
        labelKey: "LEAD_TYPE",
        optional: true,
      },
      QUALIFICATION: {
        key: "qualification.qualifier.name",
        type: FIELD_TYPES.SELECTION,
        icon: MdStar,
        labelKey: "QUALIFICATION",
        optional: true,
        operators: [
          { key: "is", labelKey: "IS_SELECTION" },
          { key: "is_not", labelKey: "IS_NOT" },
          { key: "contains", labelKey: "CONTAINS" },
          { key: "not_contains", labelKey: "NOT_CONTAINS" },
          { key: "starts", labelKey: "STARTS" },
          { key: "ends", labelKey: "ENDS" },
          { key: "defined", labelKey: "DEFINED" },
          { key: "not_defined", labelKey: "NOT_DEFINED" },
        ],
      },
      CREATED_DATE: {
        key: "createdDate",
        type: FIELD_TYPES.DATE,
        icon: MdCalendarMonth,
        labelKey: "CREATED_DATE",
        optional: false,
      },
      LAST_ACTION: {
        key: "statuses.lastAction",
        type: FIELD_TYPES.DATE,
        icon: MdSchedule,
        labelKey: "LAST_ACTION",
        optional: false,
      },
      STATUS: {
        key: "statuses.status.tag",
        type: FIELD_TYPES.SELECTION,
        icon: MdToggleOn,
        labelKey: "STATUS",
        optional: false,
      },
      RING_COUNT: {
        key: "contact.countedCallsCount",
        type: FIELD_TYPES.NUMBER,
        icon: MdCall,
        labelKey: "RING_COUNT",
        optional: true,
        visibleWhen: (ctx) => ctx.isRingEnabled,
      },
      ORIGIN: {
        key: "tracer.source.name",
        type: FIELD_TYPES.SELECTION,
        icon: MdLanguage,
        labelKey: "ORIGIN",
        optional: true,
      },
      OFFER: {
        key: "tracer.name",
        type: FIELD_TYPES.SELECTION,
        icon: MdInventory2,
        labelKey: "OFFER",
        optional: true,
      },
      SUPERVISOR: {
        key: "author.supervisor.id",
        type: FIELD_TYPES.SELECTION,
        icon: MdSupervisorAccount,
        labelKey: "SUPERVISOR",
        optional: true,
        visibleWhen: (ctx) => ctx.isAdmin,
      },
      ADVISOR: {
        key: "author.id",
        type: FIELD_TYPES.SELECTION,
        icon: MdBadge,
        labelKey: "ADVISOR",
        optional: true,
        visibleWhen: (ctx) => ctx.isAdmin,
      },
      ADVISOR_LASTNAME: {
        key: "author.lastname",
        type: FIELD_TYPES.TEXT,
        icon: MdBadge,
        labelKey: "ADVISOR_LASTNAME",
        optional: false,
        visibleWhen: (ctx) =>
          ctx.isSupervisor || ctx.isOrganizationScope || ctx.isAdmin,
      },
      ADVISOR_FIRSTNAME: {
        key: "author.firstname",
        type: FIELD_TYPES.TEXT,
        icon: MdBadge,
        labelKey: "ADVISOR_FIRSTNAME",
        optional: false,
        visibleWhen: (ctx) =>
          ctx.isSupervisor || ctx.isOrganizationScope || ctx.isAdmin,
      },
      TAKEOVER_STATUS: {
        key: "hasResponsible",
        type: FIELD_TYPES.SELECTION,
        icon: MdAssignmentTurnedIn,
        labelKey: "TAKEOVER_STATUS",
        optional: true,
        visibleWhen: (ctx) => ctx.isSupervisor,
      },
    },
  },
};
